import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { TableCell } from '@mui/material';
import { Typography, Tooltip } from '@material-ui/core';

const useStyles = makeStyles({
  typographyStyles: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18.62px',
  },
  cellStyles: {
    padding: '1px !important',
  },
  other: {
    '.borderRightHalf::after': {
      content: '',
      position: 'absolute',
      top: '25%',
      bottom: '25%',
      right: '0',
      width: '1px',
      backgroundColor: 'black',
    },
  },
});

const CustomTableCell = props => {
  const { children, className, typographyClassName, hasTooltip, tooltip } = props;
  const classes = useStyles();
  return hasTooltip ? (
    <TableCell className={`${className ?? classes.cellStyles} ${classes.other}`}>
      <Tooltip arrow placement="top" title={<h3>{tooltip}</h3>}>
        <Typography className={`${typographyClassName} ${classes.typographyStyles}`}>{children}</Typography>
      </Tooltip>
    </TableCell>
  ) : (
    <TableCell className={`${className ?? classes.cellStyles} ${classes.other}`}>
      <Typography className={`${typographyClassName} ${classes.typographyStyles}`}>{children}</Typography>
    </TableCell>
  );
};

CustomTableCell.defaultProps = {
  className: null,
  typographyClassName: null,
  hasTooltip: false,
  tooltip: null,
};

CustomTableCell.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.any,
  typographyClassName: PropTypes.any,
  hasTooltip: PropTypes.bool,
  tooltip: PropTypes.object,
};

export default CustomTableCell;
